import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

interface ColourIndicatorStylesProps {
  add?: boolean
  colour: string
}
const useStyles = makeStyles<Theme, ColourIndicatorStylesProps>(theme => ({
  dot: {
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: ({ add }) => (add ? '18px' : '11px'),
    height: ({ add }) => (add ? '18px' : '11px'),
    border: ({ colour }) =>
      //@ts-ignore
      colour ? '#ffffff' : `1px solid ${theme.border.outline}`
  }
}))

export default useStyles
